<!-- TODO add top prop which will move the icon vertically for n px
     ATM it has to be done on every icon with css selector and top attribute. -->

<!--
make it react to parent hover - DONE
* TODO - improvement - add prop which signals direction so there can be one icon, e.g. arrow, which can then be rotated with a propbundleRenderer.renderToStream
* TODO - improvement - add animation option, e.g animation between direction or endles animation like rotation
* TODO - improvement - add option to make the icon invisible
* TODO - improvement - add options for shadow
* TODO - improvement - add option for border
* TODO - improvement - reenable hover opacity but using a prop
* TODO - improvement - remove pointer events from icon elements and allow it only on the wrapper element so it is easier to detect from other components that the icon is clicked. This way we have to check if the icon is clicked or the wrapper is clicked.

Add "child-icon-hover" CSS class to a parent element to trigger icon hover state when when that parent element is hovered
Add "child-icon-active" CSS class to a parent element to trigger icon active state
@todo: see if extra parameters are needed in case of parent hover/active states

Example:
* Hovering over #parent-element will trigger hover colors/state on icon
<div
  id="parent-element"
  class="child-icon-hover"
  :class="{'child-icon-active': someComponentMethod}">
  <SBIcon
    :icon="SBIconList.PHONE"
    :size="10"
    :color="SBColors.blackUltralight"
    :hover-icon-color="SBColors.blackPrimary"/>
</div>
-->

<template>
  <div
    :style="wrapperVars"
    class="sb-icon no-shrink"
    :class="{
      active: active,
      pointer: pointer,
    }"
    @click="$emit('click')">
    <!-- TODO change this to emit clicked and set .stop to @click. This will prevent bubbling. -->
    <span
      class="hover-background" />
    <span
      class="icon"
      :style="cssVars"
      :class="[icon.cssClass, {mask: mask, 'mask-hover': maskHover, spin}]" />
    <template v-if="counter">
      <div class="counter">
        {{ counter }}
      </div>
    </template>
  </div>
</template>

<script>
import SBColors from '@/helpers/lists/colors';

/**
 * AI Number icon component for displaying specific icons not available from font-awesome or bootstrap.
 *
 * @param color Optional. Color of the icon. Accepts hex, RGB(A), HSL(A) notation or keyword.
 * @param icon Icon object from SBIconList.
 * @param size Optional. Size of the icon.
 */
export default {
  name: 'SBIcon',
  props: {
    active: {
      type: Boolean,
      required: false,
      default: false,
    },
    animate: {
      type: Boolean,
      required: false,
      default: false,
    },
    backgroundColor: {
      type: String,
      required: false,
      default: 'transparent',
    },
    color: {
      type: String,
      required: false,
      default: SBColors.blackPrimary,
    },
    icon: {
      type: Object,
      required: true,
    },
    hoverColor: {
      type: String,
      required: false,
      default: '',
    },
    hoverIcon: {
      type: Object,
      required: false,
      default: null,
    },
    hoverIconColor: {
      type: String,
      required: false,
      default: null,
    },
    hoverSize: {
      type: Number,
      required: false,
      default: null,
    },
    borderRadius: {
      type: Number,
      required: false,
      default: 5,
    },
    borderColor: {
      type: String,
      required: false,
      default: null,
    },
    borderWidth: {
      type: Number,
      required: false,
      default: 0,
    },
    mask: {
      type: Boolean,
      required: false,
      default: true,
    },
    maskHover: {
      type: Boolean,
      required: false,
      default: true,
    },
    pointer: {
      type: Boolean,
      required: false,
      default: false,
    },
    size: {
      type: Number,
      required: false,
      default: 30,
    },
    spin: {
      type: Boolean,
      required: false,
      default: false,
    },
    counter: {
      type: Number,
      required: false,
      default: null,
    },
    rotate: {
      type: Number,
      required: false,
      default: 0,
    },
  },
  computed: {
    /**
     * Css variables to be included to css.
     */
    cssVars() {
      return {
        '--size': `${this.size}px`,
        '--color': this.color,
        '--icon-data': `url(${this.iconData})`,
        '--hover-icon-data': `url(${this.hoverIconData})`,
        '--hover-icon-color': this.hoverIconColor ? this.hoverIconColor : this.color,
        '--rotate': `${this.rotate}deg`,
      };
    },
    /**
     * Returns the image data as base64 for the required hover image.
     */
    hoverIconData() {
      // eslint-disable-next-line
      return this.hoverIcon ? require(`@/assets/img/SB-Icons/${this.hoverIcon.fileName}`) : this.iconData;
    },
    /**
     * Returns the image data as base64 for the required image.
     */
    iconData() {
      // eslint-disable-next-line
      return require(`@/assets/img/SB-Icons/${this.icon.fileName}`);
    },
    wrapperVars() {
      return {
        '--background-color': this.backgroundColor,
        '--hover-color': this.hoverColor || this.backgroundColor,
        '--hover-size': this.hoverSize ? `${this.hoverSize}px` : `${this.size}px`,
        '--border-radius': `${this.borderRadius}px`,
        '--border-color': `${this.borderColor}`,
        '--border-width': `${this.borderWidth}px`,
        '--width': this.counter ? 'auto' : this.hoverSize ? `${this.hoverSize}px` : `${this.size}px`,
        '--padding': this.counter ? '0px 9px' : '0px',
        '--transition': this.animate ? 'all 0.3s' : 'all 0s',
      };
    },
  },
};
</script>

<style lang="scss" scoped>
@keyframes spin {
  100% {
    transform: rotate(360deg);
  }
}

.sb-icon {
  position: relative;
  width: var(--width);
  height: var(--hover-size);
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: var(--background-color);
  border-radius: var(--border-radius);
  border-color: var(--border-color);
  border-width: var(--border-width);
  border-style: solid;
  padding: var(--padding);

  &.pointer {
    cursor: pointer;
  }

  &:hover {
    // border-color: var(--hover-color);
    background-color: var(--hover-color);
  }

  &:hover span.hover-background, &.active span.hover-background {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background-color: var(--hover-color);
    border-radius: var(--border-radius);
    // opacity: 0.82;
    z-index: 0;
  }

  span.icon {
    display: inline-block;
    width: var(--size);
    height: var(--size);
    background-size: var(--size);
    background-image: var(--icon-data) !important;
    background-repeat: no-repeat;
    background-position: center;
    transform: rotate(var(--rotate));
    transition: var(--transition);
    flex-shrink: 0;

    &.mask {
      background-image: unset !important;
      background-color: var(--color) !important;
      mask: var(--icon-data) no-repeat center !important;
      -webkit-mask: var(--icon-data) no-repeat center !important;
      mask-size: var(--size) var(--size) !important;
      -webkit-mask-size: var(--size) var(--size) !important;
    }

    &.spin {
      animation: spin 1s linear infinite;
    }
  }

  &:hover span.icon, &.active span.icon {
    background-color: unset !important;
    mask: unset !important;
    -webkit-mask: unset !important;
    background-image: var(--hover-icon-data) !important;
    z-index: 1;

    &.mask-hover {
      background-image: unset !important;
      background-color: var(--hover-icon-color) !important;
      mask: var(--hover-icon-data) no-repeat center !important;
      -webkit-mask: var(--hover-icon-data) no-repeat center !important;
      mask-size: var(--size) var(--size) !important;
      -webkit-mask-size: var(--size) var(--size) !important;
    }
  }

  .counter {
    border-left: 2px solid $greyBorder;
    padding-left: 9px;
    margin-left: 9px;
    font-size: 14px;
    font-weight: 500;
    color: $bluePrimary;
    min-width: 20px;
  }
}

// adding rule so parent can activate hover and active state
// tested if it can be scoped - it can
.child-icon-hover:hover .sb-icon,
.child-icon-active .sb-icon {
  // was .sb-icon:hover span.hover-background, .sb-icon.active span.hover-background {
  span.hover-background {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background-color: var(--hover-color);
    border-radius: var(--border-radius);
    opacity: 0.82;
    z-index: 0;
  }

  // was .sb-icon:hover span.icon, .sb-icon.active span.icon {
  span.icon {
    background-color: unset !important;
    mask: unset !important;
    -webkit-mask: unset !important;
    background-image: var(--hover-icon-data) !important;
    z-index: 1;

    &.mask-hover {
      background-image: unset !important;
      background-color: var(--hover-icon-color) !important;
      mask: var(--hover-icon-data) no-repeat center !important;
      -webkit-mask: var(--hover-icon-data) no-repeat center !important;
      mask-size: var(--size) var(--size) !important;
      -webkit-mask-size: var(--size) var(--size) !important;
    }
  }
}
</style>
